import React from 'react';

const features = [
  {
    id: 'feat-distribute',
    icon: '🌐',
    title: 'Distribute to 150+ Platforms',
    desc: 'Spotify, Apple Music, JioSaavn, Wynk, YouTube, TikTok, Amazon Music and more.',
  },
  {
    id: 'feat-qc',
    icon: '✅',
    title: 'Automated QC Engine',
    desc: 'AI-powered quality checks on metadata, audio, and artwork before submission.',
  },
  {
    id: 'feat-analytics',
    icon: '📊',
    title: 'Real-Time Analytics',
    desc: 'Track streams, downloads, and revenue across every platform in one place.',
  },
  {
    id: 'feat-royalties',
    icon: '💰',
    title: 'Royalty Management',
    desc: 'Transparent earnings breakdowns and direct payouts via UPI & Bank Transfer.',
  },
];

const highlights = [
  { id: 'hl-stores', value: '150+', label: 'Global DSP Stores' },
  { id: 'hl-qc', value: '24-48h', label: 'Fast QC Delivery' },
  { id: 'hl-rights', value: '100%', label: 'Master Rights Retention' },
];

export default function BrandPanel() {
  return (
    <div
      className="hidden lg:flex lg:w-[520px] xl:w-[580px] flex-col justify-between p-12 relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #0d0d18 0%, #13131a 40%, #1a0a2e 100%)',
        borderRight: '1px solid var(--border)',
      }}
    >
      {/* Background decoration */}
      <div
        className="absolute top-0 right-0 w-96 h-96 rounded-full opacity-10 pointer-events-none"
        style={{
          background: 'radial-gradient(circle, var(--primary) 0%, transparent 70%)',
          transform: 'translate(30%, -30%)',
        }}
      />
      <div
        className="absolute bottom-0 left-0 w-64 h-64 rounded-full opacity-5 pointer-events-none"
        style={{
          background: 'radial-gradient(circle, var(--accent) 0%, transparent 70%)',
          transform: 'translate(-30%, 30%)',
        }}
      />

      {/* Logo */}
      <div className="relative z-10">
        <div className="flex items-center mb-12">
          <img
            src="/assets/images/Brown_Minimalist_YouTube_Banner__3000_x_3000_px_-1787252454715.png"
            alt="TubeNexa Logo"
            className="h-20 w-auto object-contain"
          />
        </div>

        {/* Hero copy */}
        <div className="mb-10">
          <h2 className="text-3xl xl:text-4xl font-bold leading-tight mb-4" style={{ color: 'var(--foreground)' }}>
            Distribute your music
            <br />
            <span className="text-gradient-primary">to the world.</span>
          </h2>
          <p className="text-base leading-relaxed" style={{ color: 'var(--secondary-foreground)' }}>
            Professional music distribution with automated quality control, admin approval workflow, and real-time delivery tracking across every major platform.
          </p>
        </div>

        {/* Features */}
        <div className="space-y-4">
          {features?.map((f) => (
            <div key={f?.id} className="flex items-start gap-4">
              <div
                className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 text-lg"
                style={{ background: 'rgba(124, 58, 237, 0.15)', border: '1px solid rgba(124, 58, 237, 0.2)' }}
              >
                {f?.icon}
              </div>
              <div>
                <p className="text-sm font-semibold mb-0.5" style={{ color: 'var(--foreground)' }}>
                  {f?.title}
                </p>
                <p className="text-xs leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
                  {f?.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Verified Highlights */}
      <div
        className="relative z-10 flex items-center gap-8 pt-8"
        style={{ borderTop: '1px solid var(--border)' }}
      >
        {highlights?.map((h) => (
          <div key={h?.id}>
            <p className="text-2xl font-bold font-mono-data" style={{ color: 'var(--primary-light)' }}>
              {h?.value}
            </p>
            <p className="text-xs mt-0.5" style={{ color: 'var(--muted-foreground)' }}>
              {h?.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}